const str = (v: unknown): string => (typeof v === 'string' ? v.trim() : '') || '';

export interface ProductFieldSource {
  strain?: string;
  strainName?: string;
  productName?: string;
  name?: string;
  title?: string;
  subSpecies?: string;
  subspeciesName?: string;
  productCategoryName?: string;
  category?: string;
  [key: string]: unknown;
}

export interface ResolvedProductFields {
  strain: string;
  productName: string;
  subSpecies: string;
  productCategoryName: string;
}

//resolve product fields with this priority: override > ridProduct > mca.
export function resolveProductFields(
  override?: ProductFieldSource | null,
  ridProduct?: ProductFieldSource | null,
  mca?: ProductFieldSource | null,
): ResolvedProductFields {
  const strain =
    str(override?.strain) || str(override?.strainName) ||
    str(ridProduct?.strain) || str(ridProduct?.strainName) ||
    str(mca?.strainName) || str(mca?.strain) || '';

  const productName =
    str(override?.productName) || str(override?.name) || str(override?.title) ||
    str(ridProduct?.productName) || str(ridProduct?.name) || str(ridProduct?.title) ||
    str(mca?.productName) || str(mca?.name) || '';

  const subSpecies =
    str(override?.subSpecies) || str(override?.subspeciesName) ||
    str(ridProduct?.subSpecies) || str(ridProduct?.subspeciesName) ||
    str(mca?.subSpecies) || str(mca?.subspeciesName) || '';

  const productCategoryName =
    str(override?.productCategoryName) || str(override?.category) ||
    str(ridProduct?.productCategoryName) || str(ridProduct?.category) ||
    str(mca?.productCategoryName) || str(mca?.category) || '';

  return { strain, productName, subSpecies, productCategoryName };
}
